import { makeStyles } from '@material-ui/core/styles'

const WEATHER_WIDGET_HEIGHT = 255

const useStyles = makeStyles((theme) => ({
  weatherContainer: {
    minHeight: WEATHER_WIDGET_HEIGHT,
  },
  weatherColor: {
    backgroundColor: theme.palette.primary.light,
    borderRadius: '15px',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflow: 'hidden',
    width: '100%',
  },
  colorLetter: {
    color: 'white',
  },
  mainWeatherIcon: {
    width: '92px',
    height: '92px',
    objectFit: 'contain',
    [theme.breakpoints.down('sm')]: {
      width: '64px',
      height: '64px',
    },
  },
  divider: {
    background: theme.palette.divider,
  },
  currentDay: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    minHeight: WEATHER_WIDGET_HEIGHT,
  },
  weatherForecastColumn: {
    display: 'flex',
  },
  weatherForecastDay: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  forecastWeatherIcon: {
    width: '68px',
    height: '68px',
    objectFit: 'contain',
    [theme.breakpoints.down('sm')]: {
      width: '48px',
      height: '48px',
    },
  },
  forecastDivider: {
    background: 'white',
    height: '1px',
  },
  heightContentSpinner: {
    height: WEATHER_WIDGET_HEIGHT,
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
  },
}))

export default useStyles
